import { type PayloadAction, createSlice } from "@reduxjs/toolkit"
import { IPlayerSliceState } from "."

export const initialState: IPlayerSliceState = {
  isPlayerLoaded: false,
  isAuthorized: false
}

export const PlayerSlice = createSlice({
  name: "player",
  initialState,
  reducers: {
    setIsPlayerLoaded: (
      state,
      { payload }: PayloadAction<IPlayerSliceState["isPlayerLoaded"]>
    ) => {
      state.isPlayerLoaded = payload
    },
    setIsAuthorized: (
      state,
      { payload }: PayloadAction<IPlayerSliceState["isAuthorized"]>
    ) => {
      state.isAuthorized = payload
    }
  }
})

export const { setIsPlayerLoaded, setIsAuthorized } = PlayerSlice.actions
